module.exports = __webpack_public_path__ + "static/img/chakanjietu.2a5032c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/blue/chakanjietu.png
// module id = x0UL
// module chunks = 24